/**
 * @param {unknown} value
 * @returns {boolean}
 */
function isObjectIdString(value) {
  return typeof value === 'string' && /^[a-f0-9]{24}$/i.test(value.trim());
}

function cityLabel(city) {
  if (!city) return '';
  if (typeof city === 'object') {
    return city.cityName || city.name || '';
  }
  if (typeof city === 'string' && !isObjectIdString(city)) return city;
  return '';
}

function cleanAddressPart(value) {
  if (value == null) return '';
  const text = String(value).trim();
  if (!text || isObjectIdString(text)) return '';
  return text;
}

/**
 * @param {object | null | undefined} shop
 * @returns {string}
 */
export function formatShopAddress(shop) {
  if (!shop?.address) return '';
  const a = shop.address;
  const parts = [a.fullAddress, a.landmark, cityLabel(a.city), a.state, a.postalCode, a.country]
    .map(cleanAddressPart)
    .filter(Boolean);
  return [...new Set(parts)].join(', ');
}

/**
 * Prefer populated product.shop; fallback to selected shop from context.
 */
export function shopForProduct(product, selectedShop) {
  if (product?.shop && typeof product.shop === 'object') return product.shop;
  return selectedShop || null;
}
